/* GENERATED by scripts/gen-data.mjs — chapter "frontend-composition" (from s2.js + s3.js).
 * Structure only: every string is an i18n key resolved from
 * src/i18n/locales/<lang>/. Edit the content in the artifact and re-run
 * npm run extract, do not hand-edit here. */

import type { NodeDef } from '../../types';

export const N_FRONTEND_COMPOSITION: NodeDef = {
  "id": "frontend-composition",
  "tagKey": "path:frontend-composition.tag",
  "x": 320,
  "y": 300,
  "w": 220,
  "h": 116,
  "titleKey": "path:frontend-composition.title",
  "subKey": "path:frontend-composition.sub",
  "blocks": [
    {
      "id": "frontend-composition.b1",
      "kind": "explain",
      "xp": 15,
      "titleKey": "path:frontend-composition.b1.title",
      "bodyKey": "path:frontend-composition.b1.body",
      "flowKey": "path:frontend-composition.b1.flow"
    },
    {
      "id": "frontend-composition.b2",
      "kind": "film",
      "xp": 25,
      "titleKey": "path:frontend-composition.b2.title",
      "film": "f-frontend"
    },
    {
      "id": "frontend-composition.b3o",
      "kind": "options",
      "xp": 20,
      "titleKey": "path:frontend-composition.b3o.title",
      "opts": {
        "list": [
          {
            "nKey": "path:frontend-composition.b3o.opts.0.n",
            "wKey": "path:frontend-composition.b3o.opts.0.w",
            "uKey": "path:frontend-composition.b3o.opts.0.u",
            "cKey": "path:frontend-composition.b3o.opts.0.c",
            "slug": "monorepo-packages"
          },
          {
            "nKey": "path:frontend-composition.b3o.opts.1.n",
            "wKey": "path:frontend-composition.b3o.opts.1.w",
            "uKey": "path:frontend-composition.b3o.opts.1.u",
            "cKey": "path:frontend-composition.b3o.opts.1.c",
            "slug": "runtime-remotes"
          },
          {
            "nKey": "path:frontend-composition.b3o.opts.2.n",
            "wKey": "path:frontend-composition.b3o.opts.2.w",
            "uKey": "path:frontend-composition.b3o.opts.2.u",
            "cKey": "path:frontend-composition.b3o.opts.2.c",
            "slug": "iframes"
          },
          {
            "nKey": "path:frontend-composition.b3o.opts.3.n",
            "wKey": "path:frontend-composition.b3o.opts.3.w",
            "uKey": "path:frontend-composition.b3o.opts.3.u",
            "cKey": "path:frontend-composition.b3o.opts.3.c",
            "slug": "server-or-edge-composition"
          }
        ],
        "ref": "mfe"
      }
    },
    {
      "id": "frontend-composition.b3",
      "kind": "math",
      "xp": 15,
      "titleKey": "path:frontend-composition.b3.title",
      "math": {
        "exprKey": "path:frontend-composition.b3.math.expr",
        "readKey": "path:frontend-composition.b3.math.read",
        "useKey": "path:frontend-composition.b3.math.use"
      }
    },
    {
      "id": "frontend-composition.b4",
      "kind": "check",
      "xp": 45,
      "titleKey": "path:frontend-composition.b4.title",
      "ex": {
        "type": "choice",
        "options": [
          {
            "tKey": "path:frontend-composition.b4.ex.options.0.t",
            "ok": true,
            "fbKey": "path:frontend-composition.b4.ex.options.0.fb"
          },
          {
            "tKey": "path:frontend-composition.b4.ex.options.1.t",
            "ok": false,
            "fbKey": "path:frontend-composition.b4.ex.options.1.fb"
          },
          {
            "tKey": "path:frontend-composition.b4.ex.options.2.t",
            "ok": false,
            "fbKey": "path:frontend-composition.b4.ex.options.2.fb"
          }
        ]
      }
    }
  ]
};
